import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["icon"];

  connect() {
    this.render();
  }

  toggle() {
    const isDark = document.documentElement.classList.toggle("dark");
    try {
      localStorage.setItem("theme", isDark ? "dark" : "light");
    } catch (_e) {}
    this.render();
  }

  render() {
    if (!this.hasIconTarget) return;
    const isDark = document.documentElement.classList.contains("dark");
    this.iconTarget.textContent = isDark ? "☀️" : "🌙";
    this.element.setAttribute(
      "aria-label",
      isDark ? "Switch to light mode" : "Switch to dark mode",
    );
  }
}
